export enum SubscriberRegistrationStatus {
  NEED_CONFIRM = 'need_confirm',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}
